/** Central route paths — align with /app/* as features mature */
export const ROUTES = {
  HOME: '/',
  GAME: '/game',
  NEURO_SELECTOR: '/neuro-selector',
  COMPANION_ONBOARDING: '/companion-onboarding',
  COMPANION_BUDDY: '/companion-buddy',
  LOGIN: '/login',
  GUEST_ENTRY: '/guest',
  SIGNUP: '/signup',
  FORGOT_PASSWORD: '/forgot-password',
  TRUST_AND_SAFETY: '/trust-and-safety',
  EVIDENCE: '/evidence',
  CHILD_DASHBOARD: '/dashboard',
  CHILD_ACTIVITY_LOG: '/activity-log',
  AUTISM_SPACE: '/autism-space',
  CHILD_SETTINGS: '/settings',
  WRITING_PAD: '/writing-pad',
  PRONUNCIATION_BUDDY: '/pronunciation-buddy',
  PARENT_HUB: '/parent-hub',
  MUSIC: '/music',
  TEACHER_LOGIN: '/teacher',
  TEACHER_DASHBOARD: '/teacher/dashboard',
  TEACHER_CLASSES: '/teacher/classes',
  TEACHER_STUDENTS: '/teacher/students',
  TEACHER_ASSIGNMENTS: '/teacher/assignments',
  TEACHER_SIGNALS: '/teacher/signals',
  TEACHER_MESSAGES: '/teacher/messages',
  TEACHER_REPORTS: '/teacher/reports',
  TEACHER_ACTIVITY_LOG: '/teacher/activity-log',
  TEACHER_SETTINGS: '/teacher/settings',
  TEACHER_CLASSROOM_LIVE: '/teacher/classroom/:sessionId',
  CHILD_CLASSROOM_LIVE: '/classroom/live/:sessionId',
  ADMIN_LOGIN: '/admin/login',
  ADMIN_DASHBOARD: '/admin',
  ADMIN_USERS: '/admin/users',
  ADMIN_ACTIVITY: '/admin/activity',
  ADMIN_AUDIT: '/admin/audit',
  ADMIN_SETTINGS: '/admin/settings',
} as const;
